<template>
  <div>
    <el-dialog
      class="add-report-dialog"
      v-model="dialogVisible"
      title="提示"
      width="500"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :fullscreen="fullscreen"
      @close="beforeclose"
      draggable
    >
      <template #header="{ close, titleId, titleClass }">
        <div class="dialog-header">
          <h6>提示</h6>
          <div class="dialog-header-btns">
            <el-icon :size="17" @click="fullscreen = !fullscreen">
              <FullScreen v-if="!fullscreen" />
              <CopyDocument v-else />
            </el-icon>
            <el-icon :size="20" color="#000000" @click="close"><Close /></el-icon>
          </div>
        </div>
      </template>

      <div style="padding: 10px 100px 0">
        <el-form ref="formRef" :model="formData" label-width="auto" label-suffix="：">
          <el-form-item label="报告年度" prop="reportYear" :rules="[{ required: true, message: '报告年度不能为空', trigger: 'change' }]" :required="false">
            <el-select v-model="formData.reportYear" style="width: 220px">
              <el-option v-for="(item, index) of reportYearOptions" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <p>说明：补报完成后才能填报本年度的年度报告</p>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitForm" color="#d1ab62" style="color: #ffffff" size="large">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const checkRule = inject("checkRule");

const dialogVisible = ref(false);
const fullscreen = ref(false);

const formData = ref({});

const formRef = ref(null);
const open = () => {
  dialogVisible.value = true;
};
const close = () => {
  dialogVisible.value = false;
};
const beforeclose = () => {
  formData.value = {};
};
const submitForm = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      emits("submit", formData.value);
    }
  });
};

const reportYearOptions = computed(() => {
  const reportYear = props.inspectionData.reportData.reportYear;
  if (reportYear) {
    return [
      {
        label: `${reportYear}年度报告`,
        value: reportYear,
      },
    ];
  }

  return [];
});

const emits = defineEmits(["submit"]);
defineExpose({
  open,
  close,
});
</script>

<style lang="scss" scoped>
:deep(.add-report-dialog) {
  padding: 0 !important;

  .dialog-header {
    height: 41px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(207, 169, 94);
    text-align: center;
    color: #ffffff;
    padding: 10px;
    position: relative;

    .dialog-header-btns {
      display: flex;
      align-items: center;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);

      .el-icon {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    padding: 30px 0 60px 0;
  }
}
</style>
